import React, { useEffect, useRef, useState } from 'react';
import "./aboutpage.css";
import bgVideo from "./aboutpagevideo.mp4";
import bgVideoM from "./aboutpagevideomobile.mp4";
import bgVideo2 from "./aboutpagevideoblur.mp4";
import alohaLogo from "../../assets/aloha-logo.png"
import veriusLogo from "../../assets/verius-logo.png"
import { useLanguage } from '../../context/LanguageContext';

const AboutPage = () => {
  const { t, changeLanguage } = useLanguage();
  const topRef = useRef();
  const bottomRef = useRef();
  const [isTopVisible, setIsTopVisible] = useState(false);
  const [isBottomVisible, setIsBottomVisible] = useState(false);

  useEffect(() => {
    const topObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsTopVisible(true);
          topObserver.unobserve(entry.target);
        }
      });
    });

    const bottomObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsBottomVisible(true);
          bottomObserver.unobserve(entry.target);
        }
      });
    });

    if (topRef.current) {
      topObserver.observe(topRef.current);
    }

    if (bottomRef.current) {
      bottomObserver.observe(bottomRef.current);
    }

    return () => {
      if (topRef.current) {
        topObserver.unobserve(topRef.current);
      }
      if (bottomRef.current) {
        bottomObserver.unobserve(bottomRef.current);
      }
    };
  }, []);

  return (
    <div className="about-page-container">



      <div className={`about-page-top-container ${isTopVisible ? 'fade-in' : ''}`} ref={topRef}>

        <div class="about-page-video-container about-video-web">
          <video class="aboutpage-video" src={bgVideo} autoPlay muted loop playsInline></video>
        </div>

        <div class="about-page-video-container about-video-mobile md:hidden">
          <video class="aboutpage-video" src={bgVideoM} autoPlay muted loop playsInline></video>
        </div>

        <h1 className="about-page-title1 mb-8">{t("about")}</h1>

      </div>

      <div className={`about-page-bottom-container ${isBottomVisible ? 'fade-in' : ''}`} ref={bottomRef}>
        <div className='about-page-card'>
          <h3 className='about-card-title1'>{t('about-card-title1')}</h3>
          <p className='about-card-text'>{t('about-card-text1')}</p>
          <p className='about-card-text'>{t('about-card-text2')}</p>
          <p className='about-card-text'>{t('about-card-text3')}</p>
          <p className='about-card-text'>{t('about-card-text4')}</p>
          <div className='about-logo-container'>
            <a href="https://verius.com.tr/">
              <img src={veriusLogo} alt="" />
              <span>{t('verius-link-text')}</span>
            </a>
            <a href="https://www.alohadijital.com/">
              <img src={alohaLogo} alt="" />
              <span>{t('aloha-link-text')}</span>
            </a>
          </div>
        </div>

        {/* <div className='about-page-card'>
          <h3 className='about-card-title1'>Biz Kimiz</h3>
          <p className='about-card-text'>Aloha Dijital olarak, dijital dünyada sizi ileri taşıyacak yenilikçi çözümler sunuyoruz. Teknopark'ta yer alan yazılım şirketi olarak sektördeki deneyimimiz ve uzman ekibimizle, işletmenizin dijital varlığını güçlendirmek ve sizi rekabet avantajıyla öne çıkarmak için buradayız.</p>

        </div> */}


      </div>

    </div>
  )
}

export default AboutPage
